import * as colors from './colors';

export default (style) => {
    const defaultParams = {
        separatorColor: colors.almostBlack,
        logoPurple: colors.logoPurple,
        fontSize: '20px',
        fontFamily: "'OpenSans','Helvetica Neue',Arial,sans-serif;",
        largeTextFamily: "'Crimson','Helvetica Neue',Arial,sans-serif;",
        highlightFontFamily: "'RalewayBold','Helvetica Neue',Arial,sans-serif;",
        logoFontFamily: "'Nunito','Helvetica Neue',Arial,sans-serif;",
        longTextFamily: "'Ubuntu','Helvetica Neue',Arial,sans-serif;",
        breakpoints: {
            xs: 0,
            s: 640,
            sm: 768,
            md: 992,
            lg: 1200,
            xxl: 2000,
        }
    };
    const lightTheme = {
        style: "light",
        contrastBackgroundColor: "white",
        primaryColor: colors.darkPurple,
        highlightColor: colors.lightPurple,
        backgroundColor: colors.bright,
        greyHighlight: colors.darkGrey,
        grey: colors.brightGrey,
        extraContrast: colors.pink,
        highlightAlternate: colors.darkBlue,
    };

    const darkTheme = {
        style: "dark",
        contrastBackgroundColor: "red",
        primaryColor: colors.lightPurple,
        highlightColor: colors.darkPurple,
        backgroundColor: colors.darkPurple,
        greyHighlight: colors.brightGrey,
        grey: colors.darkGrey,
        extraContrast: colors.pink,
        highlightAlternate: 'blue',
    };

    if(style === 'light') {
        return {...defaultParams, ...lightTheme};
    } else {
        return {...defaultParams, ...darkTheme};
    }
};
